var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaDiscountsLockUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 9.16667V6.66667C5.8335 4.36548 7.69898 2.5 10.0002 2.5C12.016 2.5 13.6974 3.93147 14.0835 5.83333M7.3335 17.5H12.6668C14.067 17.5 14.767 17.5 15.3018 17.2275C15.7722 16.9878 16.1547 16.6054 16.3943 16.135C16.6668 15.6002 16.6668 14.9001 16.6668 13.5V13.1667C16.6668 11.7665 16.6668 11.0665 16.3943 10.5317C16.1547 10.0613 15.7722 9.67883 15.3018 9.43915C14.767 9.16667 14.067 9.16667 12.6668 9.16667H7.3335C5.93336 9.16667 5.2333 9.16667 4.69852 9.43915C4.22811 9.67883 3.84566 10.0613 3.60598 10.5317C3.3335 11.0665 3.3335 11.7665 3.3335 13.1667V13.5C3.3335 14.9001 3.3335 15.6002 3.60598 16.135C3.84566 16.6054 4.22811 16.9878 4.69852 17.2275C5.2333 17.5 5.93336 17.5 7.3335 17.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaDiscountsLockUnlocked);
export default __webpack_public_path__ + "static/media/aa-discounts-lock-unlocked.a679ebe765ad67422e0162dea295738e.svg";
export { ForwardRef as ReactComponent };